
export default function setThemeColor({ primary, secondary, btnHover }) {
    document.documentElement.style.setProperty('--dark', primary);
    document.documentElement.style.setProperty('--secondary', secondary);
    document.documentElement.style.setProperty('--btnHover', btnHover);
}